<mat-select placeholder="Select field:"
            class="full-width"
            (selectionChange)="change($event)"
            [(ngModel)]="selected">
  <mat-option *ngFor="let option of options"
    [value]="option.fieldName">
    {{ option.fieldLabel + ' (' + option.fieldName + ')' }}
  </mat-option>
</mat-select>
